"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createTheme = _interopRequireDefault(require("../utils/createTheme"));

var spacing = [0, 4, 8, 16, 24, 32, 64, 128, 256, 512];
/**
 * Support for legacy font sizes on the EW front-end.
 */

var fontSizes = [0, 10, 12, 14, 16, 20, 24, 34, 48, 60, 96];
var workL = (0, _createTheme["default"])({
  colours: {
    primary: ["rgba(1, 62, 76, 1)", "rgba(1, 62, 76, 0.6)", "rgba(1, 62, 76, 0.38)", "rgba(1, 62, 76, 0.16)", "rgba(1, 62, 76, 0.12)", "rgba(1, 62, 76, 0.08)"],
    textPrimary: ["rgba(1, 62, 76, 1)"],
    secondary: ["rgba(27, 233, 110, 1)", "rgba(27, 233, 110, 0.6)", "rgba(27, 233, 110, 0.38)", "rgba(27, 233, 110, 0.16)", "rgba(27, 233, 110, 0.12)", "rgba(27, 233, 110, 0.08)"],
    tertiary: ["rgba(225, 244, 244, 1)", "rgba(225, 244, 244, 0.6)", "rgba(225, 244, 244, 0.38)", "rgba(225, 244, 244, 0.16)", "rgba(225, 244, 244, 0.12)", "rgba(225, 244, 244, 0.08)"],
    quaternary: ["rgba(0, 62, 76, 1)", "rgba(0, 62, 76, 0.6)", "rgba(0, 62, 76, 0.38)", "rgba(0, 62, 76, 0.16)", "rgba(0, 62, 76, 0.12)", "rgba(0, 62, 76, 0.08)"],
    yellow: ["rgba(247, 231, 84, 1)", "rgba(247, 231, 84, 0.6)", "rgba(247, 231, 84, 0.38)", "rgba(247, 231, 84, 0.16)", "rgba(247, 231, 84, 0.12)", "rgba(247, 231, 84, 0.08)"],
    error: ["rgba(191, 70, 48, 1)", "rgba(191, 70, 48, 0.6)", "rgba(191, 70, 48, 0.38)", "rgba(191, 70, 48, 0.16)", "rgba(191, 70, 48, 0.12)"],
    dark: ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"],
    grey: ["rgba(245, 245, 245, 1)"],
    light: ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 0.6)", "rgba(255, 255, 255, 0.38)", "rgba(255, 255, 255, 0.32)", "rgba(255, 255, 255, 0.24)", "rgba(255, 255, 255, 0.16)", "rgba(255, 255, 255, 0.12)", "rgba(255, 255, 255, 0.08)"],
    businessPrimary: ["rgba(250, 111, 0, 1)", "rgba(250, 111, 0, 0.6)", "rgba(250, 111, 0, 0.38)", "rgba(250, 111, 0, 0.16)", "rgba(250, 111, 0, 0.12)", "rgba(250, 111, 0, 0.08)"],
    businessSecondary: ["rgba(0, 225, 255, 1)", "rgba(0, 225, 255, 0.6)", "rgba(0, 225, 255, 0.38)", "rgba(0, 225, 255, 0.16)", "rgba(0, 225, 255, 0.12)", "rgba(0, 225, 255, 0.08)"]
  },
  fonts: {
    serif: "Tiempos",
    sansSerif: "Centra"
  },
  space: spacing,
  fontSizes: fontSizes
});
var _default = workL;
exports["default"] = _default;